import { beginnerDict } from './beginner';
import { intermediateDict } from './intermediate';
import { advancedDict } from './advanced';
import { commonDict } from './common';
import { LANG_ORDER } from './languages';

export const fullDictionary = {
  ...beginnerDict,
  ...intermediateDict,
  ...advancedDict,
  ...commonDict
};

export { LANG_ORDER };
